<template>
    <div id="monthsTitle" class="flex flex-row items-stretch justify-between md:flex-col md:mx-2">
        <button
            @click="toMonthNav(index)"
            v-for="(month, index) in monthsTitle" :key="index"
            :class="[
                month.danger === true ? 'bg-red-400 text-red-900' : 'bg-blue-200 text-blue-800',
                'flex-1 md:min-w-full font-bold py-2 px-3 md:py-4 md:px-4 mx-1 my-1 md:my-1 rounded']">
            {{ month.text }}
        </button>
    </div>
</template>

<script>
// import { db } from '@/db.js';
import dayjs from 'dayjs';
import { mapFields } from 'vuex-map-fields';

export default {
    name: 'MonthsList',
    props: {
        'payments-list': Array,
    },
    components: {
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapFields([
        ]),
        monthsTitle() {
            const array = [];
            for (let index = 0; index < 5; index += 1) {
                const warn = this.paymentsList.some(x => dayjs(x.date).format('YYYYMM') === dayjs().add(index, 'month').format('YYYYMM') && x.kum < 0);
                array.push({
                    text: dayjs().add(index, 'month').format('MMM'),
                    year: dayjs().add(index, 'month').format('YYYY'),
                    monthYearValue: dayjs().add(index, 'month').format('MMMM') + dayjs().add(index, 'month').format('YYYY'),
                    danger: warn,
                    id: index,
                });
            }
            return array;
        },
    },
    created() {
    },
    methods: {
        toMonthNav(index) {
            const { monthYearValue } = this.monthsTitle[index];
            const element = document.getElementById(monthYearValue);
            if (element) {
                element.scrollIntoView();
            }
        },
    },
};
</script>

<style scoped>
</style>
